import { E償却方法 } from '@/openapi/enum';

export type 計算用償却率 = {
  耐用年数: number;
  償却率: number;
  保証率?: number;
  改定償却率?: number;
};

type 方法別償却率 = {
  償却方法: E償却方法;
  計算用償却率s: 計算用償却率[];
};

export const m償却率: 方法別償却率[] = [
  {
    償却方法: E償却方法.定率法200pct,
    計算用償却率s: [
      { 耐用年数: 2, 償却率: 1 },
      { 耐用年数: 3, 償却率: 0.667, 改定償却率: 1, 保証率: 0.11089 },
      { 耐用年数: 4, 償却率: 0.5, 改定償却率: 1, 保証率: 0.12499 },
      { 耐用年数: 5, 償却率: 0.4, 改定償却率: 0.5, 保証率: 0.108 },
      { 耐用年数: 6, 償却率: 0.333, 改定償却率: 0.334, 保証率: 0.09911 },
      { 耐用年数: 7, 償却率: 0.286, 改定償却率: 0.334, 保証率: 0.0868 },
      { 耐用年数: 8, 償却率: 0.25, 改定償却率: 0.334, 保証率: 0.07909 },
      { 耐用年数: 9, 償却率: 0.222, 改定償却率: 0.25, 保証率: 0.07126 },
      { 耐用年数: 10, 償却率: 0.2, 改定償却率: 0.25, 保証率: 0.06552 },
      { 耐用年数: 11, 償却率: 0.182, 改定償却率: 0.2, 保証率: 0.05992 },
      { 耐用年数: 12, 償却率: 0.167, 改定償却率: 0.2, 保証率: 0.05566 },
      { 耐用年数: 13, 償却率: 0.154, 改定償却率: 0.167, 保証率: 0.0518 },
      { 耐用年数: 14, 償却率: 0.143, 改定償却率: 0.167, 保証率: 0.04854 },
      { 耐用年数: 15, 償却率: 0.133, 改定償却率: 0.143, 保証率: 0.04565 },
      { 耐用年数: 16, 償却率: 0.125, 改定償却率: 0.143, 保証率: 0.04294 },
      { 耐用年数: 17, 償却率: 0.118, 改定償却率: 0.125, 保証率: 0.04038 },
      { 耐用年数: 18, 償却率: 0.111, 改定償却率: 0.112, 保証率: 0.03884 },
      { 耐用年数: 19, 償却率: 0.105, 改定償却率: 0.112, 保証率: 0.03693 },
      { 耐用年数: 20, 償却率: 0.1, 改定償却率: 0.112, 保証率: 0.03486 },
      { 耐用年数: 21, 償却率: 0.095, 改定償却率: 0.1, 保証率: 0.03335 },
      { 耐用年数: 22, 償却率: 0.091, 改定償却率: 0.1, 保証率: 0.03182 },
      { 耐用年数: 23, 償却率: 0.087, 改定償却率: 0.091, 保証率: 0.03052 },
      { 耐用年数: 24, 償却率: 0.083, 改定償却率: 0.084, 保証率: 0.02969 },
      { 耐用年数: 25, 償却率: 0.08, 改定償却率: 0.084, 保証率: 0.02841 },
      { 耐用年数: 26, 償却率: 0.077, 改定償却率: 0.084, 保証率: 0.02716 },
      { 耐用年数: 27, 償却率: 0.074, 改定償却率: 0.077, 保証率: 0.02624 },
      { 耐用年数: 28, 償却率: 0.071, 改定償却率: 0.072, 保証率: 0.02568 },
      { 耐用年数: 29, 償却率: 0.069, 改定償却率: 0.072, 保証率: 0.02463 },
      { 耐用年数: 30, 償却率: 0.067, 改定償却率: 0.072, 保証率: 0.02366 },
      { 耐用年数: 31, 償却率: 0.065, 改定償却率: 0.067, 保証率: 0.02286 },
      { 耐用年数: 32, 償却率: 0.063, 改定償却率: 0.067, 保証率: 0.02216 },
      { 耐用年数: 33, 償却率: 0.061, 改定償却率: 0.063, 保証率: 0.02161 },
      { 耐用年数: 34, 償却率: 0.059, 改定償却率: 0.063, 保証率: 0.02097 },
      { 耐用年数: 35, 償却率: 0.057, 改定償却率: 0.059, 保証率: 0.02051 },
      { 耐用年数: 36, 償却率: 0.056, 改定償却率: 0.059, 保証率: 0.01974 },
      { 耐用年数: 37, 償却率: 0.054, 改定償却率: 0.056, 保証率: 0.0195 },
      { 耐用年数: 38, 償却率: 0.053, 改定償却率: 0.056, 保証率: 0.01882 },
      { 耐用年数: 39, 償却率: 0.051, 改定償却率: 0.053, 保証率: 0.0186 },
      { 耐用年数: 40, 償却率: 0.05, 改定償却率: 0.053, 保証率: 0.01791 },
      { 耐用年数: 41, 償却率: 0.049, 改定償却率: 0.05, 保証率: 0.01741 },
      { 耐用年数: 42, 償却率: 0.048, 改定償却率: 0.05, 保証率: 0.01694 },
      { 耐用年数: 43, 償却率: 0.047, 改定償却率: 0.048, 保証率: 0.01664 },
      { 耐用年数: 44, 償却率: 0.045, 改定償却率: 0.046, 保証率: 0.01664 },
      { 耐用年数: 45, 償却率: 0.044, 改定償却率: 0.046, 保証率: 0.01634 },
      { 耐用年数: 46, 償却率: 0.043, 改定償却率: 0.044, 保証率: 0.01601 },
      { 耐用年数: 47, 償却率: 0.043, 改定償却率: 0.044, 保証率: 0.01532 },
      { 耐用年数: 48, 償却率: 0.042, 改定償却率: 0.044, 保証率: 0.01499 },
      { 耐用年数: 49, 償却率: 0.041, 改定償却率: 0.042, 保証率: 0.01475 },
      { 耐用年数: 50, 償却率: 0.04, 改定償却率: 0.042, 保証率: 0.0144 },
      { 耐用年数: 51, 償却率: 0.039, 改定償却率: 0.04, 保証率: 0.01422 },
      { 耐用年数: 52, 償却率: 0.038, 改定償却率: 0.039, 保証率: 0.01422 },
      { 耐用年数: 53, 償却率: 0.038, 改定償却率: 0.039, 保証率: 0.0137 },
      { 耐用年数: 54, 償却率: 0.037, 改定償却率: 0.038, 保証率: 0.0137 },
      { 耐用年数: 55, 償却率: 0.036, 改定償却率: 0.038, 保証率: 0.01337 },
      { 耐用年数: 56, 償却率: 0.036, 改定償却率: 0.038, 保証率: 0.01288 },
      { 耐用年数: 57, 償却率: 0.035, 改定償却率: 0.036, 保証率: 0.01281 },
      { 耐用年数: 58, 償却率: 0.034, 改定償却率: 0.035, 保証率: 0.01281 },
      { 耐用年数: 59, 償却率: 0.034, 改定償却率: 0.035, 保証率: 0.0124 },
      { 耐用年数: 60, 償却率: 0.033, 改定償却率: 0.034, 保証率: 0.0124 },
      { 耐用年数: 61, 償却率: 0.033, 改定償却率: 0.034, 保証率: 0.01201 },
      { 耐用年数: 62, 償却率: 0.032, 改定償却率: 0.033, 保証率: 0.01201 },
      { 耐用年数: 63, 償却率: 0.032, 改定償却率: 0.033, 保証率: 0.01165 },
      { 耐用年数: 64, 償却率: 0.031, 改定償却率: 0.032, 保証率: 0.01165 },
      { 耐用年数: 65, 償却率: 0.031, 改定償却率: 0.032, 保証率: 0.0113 },
      { 耐用年数: 66, 償却率: 0.03, 改定償却率: 0.031, 保証率: 0.0113 },
      { 耐用年数: 67, 償却率: 0.03, 改定償却率: 0.031, 保証率: 0.01097 },
      { 耐用年数: 68, 償却率: 0.029, 改定償却率: 0.03, 保証率: 0.01097 },
      { 耐用年数: 69, 償却率: 0.029, 改定償却率: 0.03, 保証率: 0.01065 },
      { 耐用年数: 70, 償却率: 0.029, 改定償却率: 0.03, 保証率: 0.01034 },
      { 耐用年数: 71, 償却率: 0.028, 改定償却率: 0.029, 保証率: 0.01034 },
      { 耐用年数: 72, 償却率: 0.028, 改定償却率: 0.029, 保証率: 0.01006 },
      { 耐用年数: 73, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.01063 },
      { 耐用年数: 74, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.01035 },
      { 耐用年数: 75, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.01007 },
      { 耐用年数: 76, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.0098 },
      { 耐用年数: 77, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.00954 },
      { 耐用年数: 78, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.00929 },
      { 耐用年数: 79, 償却率: 0.025, 改定償却率: 0.026, 保証率: 0.00929 },
      { 耐用年数: 80, 償却率: 0.025, 改定償却率: 0.026, 保証率: 0.00907 },
      { 耐用年数: 81, 償却率: 0.025, 改定償却率: 0.026, 保証率: 0.00884 },
      { 耐用年数: 82, 償却率: 0.024, 改定償却率: 0.024, 保証率: 0.00929 },
      { 耐用年数: 83, 償却率: 0.024, 改定償却率: 0.024, 保証率: 0.00907 },
      { 耐用年数: 84, 償却率: 0.024, 改定償却率: 0.024, 保証率: 0.00885 },
      { 耐用年数: 85, 償却率: 0.024, 改定償却率: 0.024, 保証率: 0.00864 },
      { 耐用年数: 86, 償却率: 0.023, 改定償却率: 0.023, 保証率: 0.00885 },
      { 耐用年数: 87, 償却率: 0.023, 改定償却率: 0.023, 保証率: 0.00864 },
      { 耐用年数: 88, 償却率: 0.023, 改定償却率: 0.023, 保証率: 0.00844 },
      { 耐用年数: 89, 償却率: 0.022, 改定償却率: 0.022, 保証率: 0.00863 },
      { 耐用年数: 90, 償却率: 0.022, 改定償却率: 0.022, 保証率: 0.00844 },
      { 耐用年数: 91, 償却率: 0.022, 改定償却率: 0.022, 保証率: 0.00825 },
      { 耐用年数: 92, 償却率: 0.022, 改定償却率: 0.022, 保証率: 0.00807 },
      { 耐用年数: 93, 償却率: 0.022, 改定償却率: 0.022, 保証率: 0.0079 },
      { 耐用年数: 94, 償却率: 0.021, 改定償却率: 0.021, 保証率: 0.00807 },
      { 耐用年数: 95, 償却率: 0.021, 改定償却率: 0.021, 保証率: 0.0079 },
      { 耐用年数: 96, 償却率: 0.021, 改定償却率: 0.021, 保証率: 0.00773 },
      { 耐用年数: 97, 償却率: 0.021, 改定償却率: 0.021, 保証率: 0.00757 },
      { 耐用年数: 98, 償却率: 0.02, 改定償却率: 0.02, 保証率: 0.00773 },
      { 耐用年数: 99, 償却率: 0.02, 改定償却率: 0.02, 保証率: 0.00757 },
      { 耐用年数: 100, 償却率: 0.02, 改定償却率: 0.02, 保証率: 0.00742 },
    ],
  },
  {
    償却方法: E償却方法.定率法250pct,
    計算用償却率s: [
      { 耐用年数: 2, 償却率: 1 },
      { 耐用年数: 3, 償却率: 0.833, 改定償却率: 1, 保証率: 0.02789 },
      { 耐用年数: 4, 償却率: 0.625, 改定償却率: 1, 保証率: 0.05274 },
      { 耐用年数: 5, 償却率: 0.5, 改定償却率: 1, 保証率: 0.06249 },
      { 耐用年数: 6, 償却率: 0.417, 改定償却率: 0.5, 保証率: 0.05776 },
      { 耐用年数: 7, 償却率: 0.357, 改定償却率: 0.5, 保証率: 0.05496 },
      { 耐用年数: 8, 償却率: 0.313, 改定償却率: 0.334, 保証率: 0.05111 },
      { 耐用年数: 9, 償却率: 0.278, 改定償却率: 0.334, 保証率: 0.04731 },
      { 耐用年数: 10, 償却率: 0.25, 改定償却率: 0.334, 保証率: 0.04448 },
      { 耐用年数: 11, 償却率: 0.227, 改定償却率: 0.25, 保証率: 0.04123 },
      { 耐用年数: 12, 償却率: 0.208, 改定償却率: 0.25, 保証率: 0.0387 },
      { 耐用年数: 13, 償却率: 0.192, 改定償却率: 0.2, 保証率: 0.03633 },
      { 耐用年数: 14, 償却率: 0.179, 改定償却率: 0.2, 保証率: 0.03389 },
      { 耐用年数: 15, 償却率: 0.167, 改定償却率: 0.2, 保証率: 0.03217 },
      { 耐用年数: 16, 償却率: 0.156, 改定償却率: 0.167, 保証率: 0.03063 },
      { 耐用年数: 17, 償却率: 0.147, 改定償却率: 0.167, 保証率: 0.02905 },
      { 耐用年数: 18, 償却率: 0.139, 改定償却率: 0.143, 保証率: 0.02757 },
      { 耐用年数: 19, 償却率: 0.132, 改定償却率: 0.143, 保証率: 0.02616 },
      { 耐用年数: 20, 償却率: 0.125, 改定償却率: 0.143, 保証率: 0.02517 },
      { 耐用年数: 21, 償却率: 0.119, 改定償却率: 0.125, 保証率: 0.02408 },
      { 耐用年数: 22, 償却率: 0.114, 改定償却率: 0.125, 保証率: 0.02296 },
      { 耐用年数: 23, 償却率: 0.109, 改定償却率: 0.112, 保証率: 0.02226 },
      { 耐用年数: 24, 償却率: 0.104, 改定償却率: 0.112, 保証率: 0.02157 },
      { 耐用年数: 25, 償却率: 0.1, 改定償却率: 0.112, 保証率: 0.02058 },
      { 耐用年数: 26, 償却率: 0.096, 改定償却率: 0.1, 保証率: 0.01989 },
      { 耐用年数: 27, 償却率: 0.093, 改定償却率: 0.1, 保証率: 0.01902 },
      { 耐用年数: 28, 償却率: 0.089, 改定償却率: 0.091, 保証率: 0.01866 },
      { 耐用年数: 29, 償却率: 0.086, 改定償却率: 0.091, 保証率: 0.01803 },
      { 耐用年数: 30, 償却率: 0.083, 改定償却率: 0.084, 保証率: 0.01766 },
      { 耐用年数: 31, 償却率: 0.081, 改定償却率: 0.084, 保証率: 0.01688 },
      { 耐用年数: 32, 償却率: 0.078, 改定償却率: 0.084, 保証率: 0.01655 },
      { 耐用年数: 33, 償却率: 0.076, 改定償却率: 0.077, 保証率: 0.01585 },
      { 耐用年数: 34, 償却率: 0.074, 改定償却率: 0.077, 保証率: 0.01532 },
      { 耐用年数: 35, 償却率: 0.071, 改定償却率: 0.072, 保証率: 0.01532 },
      { 耐用年数: 36, 償却率: 0.069, 改定償却率: 0.072, 保証率: 0.01494 },
      { 耐用年数: 37, 償却率: 0.068, 改定償却率: 0.072, 保証率: 0.01425 },
      { 耐用年数: 38, 償却率: 0.066, 改定償却率: 0.067, 保証率: 0.01393 },
      { 耐用年数: 39, 償却率: 0.064, 改定償却率: 0.067, 保証率: 0.0137 },
      { 耐用年数: 40, 償却率: 0.063, 改定償却率: 0.067, 保証率: 0.01317 },
      { 耐用年数: 41, 償却率: 0.061, 改定償却率: 0.063, 保証率: 0.01306 },
      { 耐用年数: 42, 償却率: 0.06, 改定償却率: 0.063, 保証率: 0.01261 },
      { 耐用年数: 43, 償却率: 0.058, 改定償却率: 0.059, 保証率: 0.01248 },
      { 耐用年数: 44, 償却率: 0.057, 改定償却率: 0.059, 保証率: 0.0121 },
      { 耐用年数: 45, 償却率: 0.056, 改定償却率: 0.059, 保証率: 0.01175 },
      { 耐用年数: 46, 償却率: 0.054, 改定償却率: 0.056, 保証率: 0.01175 },
      { 耐用年数: 47, 償却率: 0.053, 改定償却率: 0.056, 保証率: 0.01153 },
      { 耐用年数: 48, 償却率: 0.052, 改定償却率: 0.053, 保証率: 0.01126 },
      { 耐用年数: 49, 償却率: 0.051, 改定償却率: 0.053, 保証率: 0.01102 },
      { 耐用年数: 50, 償却率: 0.05, 改定償却率: 0.053, 保証率: 0.01072 },
      { 耐用年数: 51, 償却率: 0.049, 改定償却率: 0.05, 保証率: 0.01053 },
      { 耐用年数: 52, 償却率: 0.048, 改定償却率: 0.05, 保証率: 0.01036 },
      { 耐用年数: 53, 償却率: 0.047, 改定償却率: 0.048, 保証率: 0.01028 },
      { 耐用年数: 54, 償却率: 0.046, 改定償却率: 0.048, 保証率: 0.01015 },
      { 耐用年数: 55, 償却率: 0.045, 改定償却率: 0.046, 保証率: 0.01007 },
      { 耐用年数: 56, 償却率: 0.045, 改定償却率: 0.046, 保証率: 0.00961 },
      { 耐用年数: 57, 償却率: 0.044, 改定償却率: 0.046, 保証率: 0.00952 },
      { 耐用年数: 58, 償却率: 0.043, 改定償却率: 0.044, 保証率: 0.00945 },
      { 耐用年数: 59, 償却率: 0.042, 改定償却率: 0.044, 保証率: 0.00934 },
      { 耐用年数: 60, 償却率: 0.042, 改定償却率: 0.044, 保証率: 0.00895 },
      { 耐用年数: 61, 償却率: 0.041, 改定償却率: 0.042, 保証率: 0.00892 },
      { 耐用年数: 62, 償却率: 0.04, 改定償却率: 0.042, 保証率: 0.00882 },
      { 耐用年数: 63, 償却率: 0.04, 改定償却率: 0.042, 保証率: 0.00847 },
      { 耐用年数: 64, 償却率: 0.039, 改定償却率: 0.04, 保証率: 0.00847 },
      { 耐用年数: 65, 償却率: 0.038, 改定償却率: 0.039, 保証率: 0.00847 },
      { 耐用年数: 66, 償却率: 0.038, 改定償却率: 0.039, 保証率: 0.00828 },
      { 耐用年数: 67, 償却率: 0.037, 改定償却率: 0.038, 保証率: 0.00828 },
      { 耐用年数: 68, 償却率: 0.037, 改定償却率: 0.038, 保証率: 0.0081 },
      { 耐用年数: 69, 償却率: 0.036, 改定償却率: 0.038, 保証率: 0.008 },
      { 耐用年数: 70, 償却率: 0.036, 改定償却率: 0.038, 保証率: 0.00771 },
      { 耐用年数: 71, 償却率: 0.035, 改定償却率: 0.036, 保証率: 0.00771 },
      { 耐用年数: 72, 償却率: 0.035, 改定償却率: 0.036, 保証率: 0.00751 },
      { 耐用年数: 73, 償却率: 0.034, 改定償却率: 0.035, 保証率: 0.00751 },
      { 耐用年数: 74, 償却率: 0.034, 改定償却率: 0.035, 保証率: 0.00738 },
      { 耐用年数: 75, 償却率: 0.033, 改定償却率: 0.034, 保証率: 0.00738 },
      { 耐用年数: 76, 償却率: 0.033, 改定償却率: 0.034, 保証率: 0.00726 },
      { 耐用年数: 77, 償却率: 0.032, 改定償却率: 0.033, 保証率: 0.00726 },
      { 耐用年数: 78, 償却率: 0.032, 改定償却率: 0.033, 保証率: 0.00716 },
      { 耐用年数: 79, 償却率: 0.032, 改定償却率: 0.033, 保証率: 0.00693 },
      { 耐用年数: 80, 償却率: 0.031, 改定償却率: 0.032, 保証率: 0.00693 },
      { 耐用年数: 81, 償却率: 0.031, 改定償却率: 0.032, 保証率: 0.00683 },
      { 耐用年数: 82, 償却率: 0.03, 改定償却率: 0.031, 保証率: 0.00683 },
      { 耐用年数: 83, 償却率: 0.03, 改定償却率: 0.031, 保証率: 0.00673 },
      { 耐用年数: 84, 償却率: 0.03, 改定償却率: 0.031, 保証率: 0.00653 },
      { 耐用年数: 85, 償却率: 0.029, 改定償却率: 0.03, 保証率: 0.00653 },
      { 耐用年数: 86, 償却率: 0.029, 改定償却率: 0.03, 保証率: 0.00645 },
      { 耐用年数: 87, 償却率: 0.029, 改定償却率: 0.03, 保証率: 0.00627 },
      { 耐用年数: 88, 償却率: 0.028, 改定償却率: 0.029, 保証率: 0.00627 },
      { 耐用年数: 89, 償却率: 0.028, 改定償却率: 0.029, 保証率: 0.0062 },
      { 耐用年数: 90, 償却率: 0.028, 改定償却率: 0.029, 保証率: 0.00603 },
      { 耐用年数: 91, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.00649 },
      { 耐用年数: 92, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.00632 },
      { 耐用年数: 93, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.00615 },
      { 耐用年数: 94, 償却率: 0.027, 改定償却率: 0.027, 保証率: 0.00598 },
      { 耐用年数: 95, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.00594 },
      { 耐用年数: 96, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.00578 },
      { 耐用年数: 97, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.00563 },
      { 耐用年数: 98, 償却率: 0.026, 改定償却率: 0.027, 保証率: 0.00549 },
      { 耐用年数: 99, 償却率: 0.025, 改定償却率: 0.026, 保証率: 0.00549 },
      { 耐用年数: 100, 償却率: 0.025, 改定償却率: 0.026, 保証率: 0.00546 },
    ],
  },
  {
    償却方法: E償却方法.旧定率法,
    計算用償却率s: [
      { 耐用年数: 2, 償却率: 0.684 },
      { 耐用年数: 3, 償却率: 0.536 },
      { 耐用年数: 4, 償却率: 0.438 },
      { 耐用年数: 5, 償却率: 0.369 },
      { 耐用年数: 6, 償却率: 0.319 },
      { 耐用年数: 7, 償却率: 0.28 },
      { 耐用年数: 8, 償却率: 0.25 },
      { 耐用年数: 9, 償却率: 0.226 },
      { 耐用年数: 10, 償却率: 0.206 },
      { 耐用年数: 11, 償却率: 0.189 },
      { 耐用年数: 12, 償却率: 0.175 },
      { 耐用年数: 13, 償却率: 0.162 },
      { 耐用年数: 14, 償却率: 0.152 },
      { 耐用年数: 15, 償却率: 0.142 },
      { 耐用年数: 16, 償却率: 0.134 },
      { 耐用年数: 17, 償却率: 0.127 },
      { 耐用年数: 18, 償却率: 0.12 },
      { 耐用年数: 19, 償却率: 0.114 },
      { 耐用年数: 20, 償却率: 0.109 },
      { 耐用年数: 21, 償却率: 0.104 },
      { 耐用年数: 22, 償却率: 0.099 },
      { 耐用年数: 23, 償却率: 0.095 },
      { 耐用年数: 24, 償却率: 0.092 },
      { 耐用年数: 25, 償却率: 0.088 },
      { 耐用年数: 26, 償却率: 0.085 },
      { 耐用年数: 27, 償却率: 0.082 },
      { 耐用年数: 28, 償却率: 0.079 },
      { 耐用年数: 29, 償却率: 0.076 },
      { 耐用年数: 30, 償却率: 0.074 },
      { 耐用年数: 31, 償却率: 0.072 },
      { 耐用年数: 32, 償却率: 0.069 },
      { 耐用年数: 33, 償却率: 0.067 },
      { 耐用年数: 34, 償却率: 0.066 },
      { 耐用年数: 35, 償却率: 0.064 },
      { 耐用年数: 36, 償却率: 0.062 },
      { 耐用年数: 37, 償却率: 0.06 },
      { 耐用年数: 38, 償却率: 0.059 },
      { 耐用年数: 39, 償却率: 0.057 },
      { 耐用年数: 40, 償却率: 0.056 },
      { 耐用年数: 41, 償却率: 0.055 },
      { 耐用年数: 42, 償却率: 0.053 },
      { 耐用年数: 43, 償却率: 0.052 },
      { 耐用年数: 44, 償却率: 0.051 },
      { 耐用年数: 45, 償却率: 0.05 },
      { 耐用年数: 46, 償却率: 0.049 },
      { 耐用年数: 47, 償却率: 0.048 },
      { 耐用年数: 48, 償却率: 0.047 },
      { 耐用年数: 49, 償却率: 0.046 },
      { 耐用年数: 50, 償却率: 0.045 },
      { 耐用年数: 51, 償却率: 0.044 },
      { 耐用年数: 52, 償却率: 0.043 },
      { 耐用年数: 53, 償却率: 0.043 },
      { 耐用年数: 54, 償却率: 0.042 },
      { 耐用年数: 55, 償却率: 0.041 },
      { 耐用年数: 56, 償却率: 0.04 },
      { 耐用年数: 57, 償却率: 0.04 },
      { 耐用年数: 58, 償却率: 0.039 },
      { 耐用年数: 59, 償却率: 0.038 },
      { 耐用年数: 60, 償却率: 0.038 },
      { 耐用年数: 61, 償却率: 0.037 },
      { 耐用年数: 62, 償却率: 0.036 },
      { 耐用年数: 63, 償却率: 0.036 },
      { 耐用年数: 64, 償却率: 0.035 },
      { 耐用年数: 65, 償却率: 0.035 },
      { 耐用年数: 66, 償却率: 0.034 },
      { 耐用年数: 67, 償却率: 0.034 },
      { 耐用年数: 68, 償却率: 0.033 },
      { 耐用年数: 69, 償却率: 0.033 },
      { 耐用年数: 70, 償却率: 0.032 },
      { 耐用年数: 71, 償却率: 0.032 },
      { 耐用年数: 72, 償却率: 0.032 },
      { 耐用年数: 73, 償却率: 0.031 },
      { 耐用年数: 74, 償却率: 0.031 },
      { 耐用年数: 75, 償却率: 0.03 },
      { 耐用年数: 76, 償却率: 0.03 },
      { 耐用年数: 77, 償却率: 0.03 },
      { 耐用年数: 78, 償却率: 0.029 },
      { 耐用年数: 79, 償却率: 0.029 },
      { 耐用年数: 80, 償却率: 0.028 },
      { 耐用年数: 81, 償却率: 0.028 },
      { 耐用年数: 82, 償却率: 0.028 },
      { 耐用年数: 83, 償却率: 0.027 },
      { 耐用年数: 84, 償却率: 0.027 },
      { 耐用年数: 85, 償却率: 0.026 },
      { 耐用年数: 86, 償却率: 0.026 },
      { 耐用年数: 87, 償却率: 0.026 },
      { 耐用年数: 88, 償却率: 0.026 },
      { 耐用年数: 89, 償却率: 0.026 },
      { 耐用年数: 90, 償却率: 0.025 },
      { 耐用年数: 91, 償却率: 0.025 },
      { 耐用年数: 92, 償却率: 0.025 },
      { 耐用年数: 93, 償却率: 0.025 },
      { 耐用年数: 94, 償却率: 0.024 },
      { 耐用年数: 95, 償却率: 0.024 },
      { 耐用年数: 96, 償却率: 0.024 },
      { 耐用年数: 97, 償却率: 0.023 },
      { 耐用年数: 98, 償却率: 0.023 },
      { 耐用年数: 99, 償却率: 0.023 },
      { 耐用年数: 100, 償却率: 0.023 },
    ],
  },
  {
    償却方法: E償却方法.定額法,
    計算用償却率s: [
      { 耐用年数: 2, 償却率: 0.5 },
      { 耐用年数: 3, 償却率: 0.334 },
      { 耐用年数: 4, 償却率: 0.25 },
      { 耐用年数: 5, 償却率: 0.2 },
      { 耐用年数: 6, 償却率: 0.167 },
      { 耐用年数: 7, 償却率: 0.143 },
      { 耐用年数: 8, 償却率: 0.125 },
      { 耐用年数: 9, 償却率: 0.112 },
      { 耐用年数: 10, 償却率: 0.1 },
      { 耐用年数: 11, 償却率: 0.091 },
      { 耐用年数: 12, 償却率: 0.084 },
      { 耐用年数: 13, 償却率: 0.077 },
      { 耐用年数: 14, 償却率: 0.072 },
      { 耐用年数: 15, 償却率: 0.067 },
      { 耐用年数: 16, 償却率: 0.063 },
      { 耐用年数: 17, 償却率: 0.059 },
      { 耐用年数: 18, 償却率: 0.056 },
      { 耐用年数: 19, 償却率: 0.053 },
      { 耐用年数: 20, 償却率: 0.05 },
      { 耐用年数: 21, 償却率: 0.048 },
      { 耐用年数: 22, 償却率: 0.046 },
      { 耐用年数: 23, 償却率: 0.044 },
      { 耐用年数: 24, 償却率: 0.042 },
      { 耐用年数: 25, 償却率: 0.04 },
      { 耐用年数: 26, 償却率: 0.039 },
      { 耐用年数: 27, 償却率: 0.038 },
      { 耐用年数: 28, 償却率: 0.036 },
      { 耐用年数: 29, 償却率: 0.035 },
      { 耐用年数: 30, 償却率: 0.034 },
      { 耐用年数: 31, 償却率: 0.033 },
      { 耐用年数: 32, 償却率: 0.032 },
      { 耐用年数: 33, 償却率: 0.031 },
      { 耐用年数: 34, 償却率: 0.03 },
      { 耐用年数: 35, 償却率: 0.029 },
      { 耐用年数: 36, 償却率: 0.028 },
      { 耐用年数: 37, 償却率: 0.028 },
      { 耐用年数: 38, 償却率: 0.027 },
      { 耐用年数: 39, 償却率: 0.026 },
      { 耐用年数: 40, 償却率: 0.025 },
      { 耐用年数: 41, 償却率: 0.025 },
      { 耐用年数: 42, 償却率: 0.024 },
      { 耐用年数: 43, 償却率: 0.024 },
      { 耐用年数: 44, 償却率: 0.023 },
      { 耐用年数: 45, 償却率: 0.023 },
      { 耐用年数: 46, 償却率: 0.022 },
      { 耐用年数: 47, 償却率: 0.022 },
      { 耐用年数: 48, 償却率: 0.021 },
      { 耐用年数: 49, 償却率: 0.021 },
      { 耐用年数: 50, 償却率: 0.02 },
      { 耐用年数: 51, 償却率: 0.02 },
      { 耐用年数: 52, 償却率: 0.02 },
      { 耐用年数: 53, 償却率: 0.019 },
      { 耐用年数: 54, 償却率: 0.019 },
      { 耐用年数: 55, 償却率: 0.019 },
      { 耐用年数: 56, 償却率: 0.018 },
      { 耐用年数: 57, 償却率: 0.018 },
      { 耐用年数: 58, 償却率: 0.018 },
      { 耐用年数: 59, 償却率: 0.017 },
      { 耐用年数: 60, 償却率: 0.017 },
      { 耐用年数: 61, 償却率: 0.017 },
      { 耐用年数: 62, 償却率: 0.017 },
      { 耐用年数: 63, 償却率: 0.016 },
      { 耐用年数: 64, 償却率: 0.016 },
      { 耐用年数: 65, 償却率: 0.016 },
      { 耐用年数: 66, 償却率: 0.016 },
      { 耐用年数: 67, 償却率: 0.015 },
      { 耐用年数: 68, 償却率: 0.015 },
      { 耐用年数: 69, 償却率: 0.015 },
      { 耐用年数: 70, 償却率: 0.015 },
      { 耐用年数: 71, 償却率: 0.015 },
      { 耐用年数: 72, 償却率: 0.014 },
      { 耐用年数: 73, 償却率: 0.014 },
      { 耐用年数: 74, 償却率: 0.014 },
      { 耐用年数: 75, 償却率: 0.014 },
      { 耐用年数: 76, 償却率: 0.014 },
      { 耐用年数: 77, 償却率: 0.013 },
      { 耐用年数: 78, 償却率: 0.013 },
      { 耐用年数: 79, 償却率: 0.013 },
      { 耐用年数: 80, 償却率: 0.013 },
      { 耐用年数: 81, 償却率: 0.013 },
      { 耐用年数: 82, 償却率: 0.013 },
      { 耐用年数: 83, 償却率: 0.013 },
      { 耐用年数: 84, 償却率: 0.012 },
      { 耐用年数: 85, 償却率: 0.012 },
      { 耐用年数: 86, 償却率: 0.012 },
      { 耐用年数: 87, 償却率: 0.012 },
      { 耐用年数: 88, 償却率: 0.012 },
      { 耐用年数: 89, 償却率: 0.012 },
      { 耐用年数: 90, 償却率: 0.012 },
      { 耐用年数: 91, 償却率: 0.011 },
      { 耐用年数: 92, 償却率: 0.011 },
      { 耐用年数: 93, 償却率: 0.011 },
      { 耐用年数: 94, 償却率: 0.011 },
      { 耐用年数: 95, 償却率: 0.011 },
      { 耐用年数: 96, 償却率: 0.011 },
      { 耐用年数: 97, 償却率: 0.011 },
      { 耐用年数: 98, 償却率: 0.011 },
      { 耐用年数: 99, 償却率: 0.011 },
      { 耐用年数: 100, 償却率: 0.01 },
    ],
  },
  {
    償却方法: E償却方法.旧定額法,
    計算用償却率s: [
      { 耐用年数: 2, 償却率: 0.5 },
      { 耐用年数: 3, 償却率: 0.333 },
      { 耐用年数: 4, 償却率: 0.25 },
      { 耐用年数: 5, 償却率: 0.2 },
      { 耐用年数: 6, 償却率: 0.166 },
      { 耐用年数: 7, 償却率: 0.142 },
      { 耐用年数: 8, 償却率: 0.125 },
      { 耐用年数: 9, 償却率: 0.111 },
      { 耐用年数: 10, 償却率: 0.1 },
      { 耐用年数: 11, 償却率: 0.09 },
      { 耐用年数: 12, 償却率: 0.083 },
      { 耐用年数: 13, 償却率: 0.076 },
      { 耐用年数: 14, 償却率: 0.071 },
      { 耐用年数: 15, 償却率: 0.066 },
      { 耐用年数: 16, 償却率: 0.062 },
      { 耐用年数: 17, 償却率: 0.058 },
      { 耐用年数: 18, 償却率: 0.055 },
      { 耐用年数: 19, 償却率: 0.052 },
      { 耐用年数: 20, 償却率: 0.05 },
      { 耐用年数: 21, 償却率: 0.048 },
      { 耐用年数: 22, 償却率: 0.046 },
      { 耐用年数: 23, 償却率: 0.044 },
      { 耐用年数: 24, 償却率: 0.042 },
      { 耐用年数: 25, 償却率: 0.04 },
      { 耐用年数: 26, 償却率: 0.039 },
      { 耐用年数: 27, 償却率: 0.037 },
      { 耐用年数: 28, 償却率: 0.036 },
      { 耐用年数: 29, 償却率: 0.035 },
      { 耐用年数: 30, 償却率: 0.034 },
      { 耐用年数: 31, 償却率: 0.033 },
      { 耐用年数: 32, 償却率: 0.032 },
      { 耐用年数: 33, 償却率: 0.031 },
      { 耐用年数: 34, 償却率: 0.03 },
      { 耐用年数: 35, 償却率: 0.029 },
      { 耐用年数: 36, 償却率: 0.028 },
      { 耐用年数: 37, 償却率: 0.027 },
      { 耐用年数: 38, 償却率: 0.027 },
      { 耐用年数: 39, 償却率: 0.026 },
      { 耐用年数: 40, 償却率: 0.025 },
      { 耐用年数: 41, 償却率: 0.025 },
      { 耐用年数: 42, 償却率: 0.024 },
      { 耐用年数: 43, 償却率: 0.024 },
      { 耐用年数: 44, 償却率: 0.023 },
      { 耐用年数: 45, 償却率: 0.023 },
      { 耐用年数: 46, 償却率: 0.022 },
      { 耐用年数: 47, 償却率: 0.022 },
      { 耐用年数: 48, 償却率: 0.021 },
      { 耐用年数: 49, 償却率: 0.021 },
      { 耐用年数: 50, 償却率: 0.02 },
      { 耐用年数: 51, 償却率: 0.02 },
      { 耐用年数: 52, 償却率: 0.02 },
      { 耐用年数: 53, 償却率: 0.019 },
      { 耐用年数: 54, 償却率: 0.019 },
      { 耐用年数: 55, 償却率: 0.019 },
      { 耐用年数: 56, 償却率: 0.018 },
      { 耐用年数: 57, 償却率: 0.018 },
      { 耐用年数: 58, 償却率: 0.018 },
      { 耐用年数: 59, 償却率: 0.017 },
      { 耐用年数: 60, 償却率: 0.017 },
      { 耐用年数: 61, 償却率: 0.017 },
      { 耐用年数: 62, 償却率: 0.017 },
      { 耐用年数: 63, 償却率: 0.016 },
      { 耐用年数: 64, 償却率: 0.016 },
      { 耐用年数: 65, 償却率: 0.016 },
      { 耐用年数: 66, 償却率: 0.016 },
      { 耐用年数: 67, 償却率: 0.015 },
      { 耐用年数: 68, 償却率: 0.015 },
      { 耐用年数: 69, 償却率: 0.015 },
      { 耐用年数: 70, 償却率: 0.015 },
      { 耐用年数: 71, 償却率: 0.014 },
      { 耐用年数: 72, 償却率: 0.014 },
      { 耐用年数: 73, 償却率: 0.014 },
      { 耐用年数: 74, 償却率: 0.014 },
      { 耐用年数: 75, 償却率: 0.014 },
      { 耐用年数: 76, 償却率: 0.014 },
      { 耐用年数: 77, 償却率: 0.013 },
      { 耐用年数: 78, 償却率: 0.013 },
      { 耐用年数: 79, 償却率: 0.013 },
      { 耐用年数: 80, 償却率: 0.013 },
      { 耐用年数: 81, 償却率: 0.013 },
      { 耐用年数: 82, 償却率: 0.013 },
      { 耐用年数: 83, 償却率: 0.012 },
      { 耐用年数: 84, 償却率: 0.012 },
      { 耐用年数: 85, 償却率: 0.012 },
      { 耐用年数: 86, 償却率: 0.012 },
      { 耐用年数: 87, 償却率: 0.012 },
      { 耐用年数: 88, 償却率: 0.012 },
      { 耐用年数: 89, 償却率: 0.012 },
      { 耐用年数: 90, 償却率: 0.012 },
      { 耐用年数: 91, 償却率: 0.011 },
      { 耐用年数: 92, 償却率: 0.011 },
      { 耐用年数: 93, 償却率: 0.011 },
      { 耐用年数: 94, 償却率: 0.011 },
      { 耐用年数: 95, 償却率: 0.011 },
      { 耐用年数: 96, 償却率: 0.011 },
      { 耐用年数: 97, 償却率: 0.011 },
      { 耐用年数: 98, 償却率: 0.011 },
      { 耐用年数: 99, 償却率: 0.011 },
      { 耐用年数: 100, 償却率: 0.01 },
    ],
  },
];
